'use client';
import React, { memo } from 'react';
import Image from 'next/image';

import { ITypo } from '@/app/_components/common';
import { Wrapper } from '@/app/_components/layout';
import {
	BachelorHatIcon,
	BookStarIcon,
	BulbIcon,
	CharacterBoxIcon,
	HeartGlassIcon,
	HourglassIcon,
	PassingStarIcon,
	PileBooksIcon,
	PuzzleIcon,
	ReactIcon,
	RocketIcon,
	StarSolidIcon,
} from '@/app/assets/Icons';
import { Images } from '@/app/assets/images';

const ExperienceSection = () => {
	return (
		<>
			<div className="bg-bittersweet relative">
				<Wrapper className="col gap-3 py-6 text-center text-white sm:gap-4 lg:max-w-[806px] lg:px-0 lg:py-12">
					<ITypo
						size={20}
						weight="semi"
						className="sm:text-24 mx-auto max-w-[240px] sm:max-w-full"
					>
						Trải nghiệm môi trường khác biệt cùng DLA
					</ITypo>
					<ITypo size={14} className="sm:text-16 line-clamp-none">
						Hướng đến mô hình "Cá nhân hóa chuyên sâu" cùng với
						triết lý KAIZEN, DLA không chỉ truyền đạt những kiến
						thức chuyên môn cao giúp bạn chinh phục các chứng chỉ
						quốc tế, chúng tôi cũng sẽ luôn ở bên cạnh bạn, đồng
						hành và chăm sóc trong suốt quá trình học - tự tin cam
						kết đảm bảo đầu ra cho mọi học viên.
					</ITypo>
				</Wrapper>

				<div className="absolute inset-0 text-white max-sm:hidden">
					<HourglassIcon className="absolute left-[68px] top-11" />
					<StarSolidIcon className="absolute left-[242px] top-[78px]" />
					<PileBooksIcon className="absolute bottom-7 left-[145px]" />

					<BookStarIcon className="absolute right-[140px] top-10" />
					<BulbIcon className="absolute bottom-4 right-[206px]" />
					<PuzzleIcon className="absolute bottom-14 right-10" />
				</div>
			</div>

			<div className="relative">
				<Wrapper className="py-6 lg:max-w-[1126px] lg:py-24">
					<div
						className="relative hidden min-h-[864px] w-full sm:block"
						data-aos="fade-up"
					>
						<Image
							src={Images.home.years20}
							fill
							alt="DLA Da Nang"
							className="object-cover object-center"
						/>
					</div>

					<div
						className="relative min-h-[594px] w-full sm:hidden"
						data-aos="fade-up"
					>
						<Image
							src={Images.home.years20Mobile}
							fill
							alt="DLA Da Nang"
							className="object-cover object-center"
						/>
					</div>
				</Wrapper>

				<div className="text-bittersweet absolute inset-0 max-sm:hidden">
					<RocketIcon
						className="absolute bottom-[10px] left-10"
						data-aos="fade-right"
					/>
					<BachelorHatIcon
						className="absolute bottom-[84px] left-[195px]"
						data-aos="fade-right"
					/>
					<PassingStarIcon
						className="absolute bottom-4 left-[309px]"
						data-aos="fade-right"
					/>

					<HeartGlassIcon
						className="absolute bottom-7 right-[310px]"
						data-aos="fade-left"
					/>
					<ReactIcon
						className="absolute bottom-[116px] right-[198px]"
						data-aos="fade-left"
					/>
					<CharacterBoxIcon
						className="absolute bottom-10 right-16"
						data-aos="fade-left"
					/>
				</div>
			</div>
		</>
	);
};

export default memo(ExperienceSection);
